import { metaAccount } from '@/router/meta-config'
const permissionKey = 'EVENTATTRIBUTEKEY'

export default [
  // attributes
  {
    path: '/attributes',
    name: 'page-attributes',
    component: () => import('@/pages/attributes'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/attribute/new',
    name: 'page-attribute-new',
    component: () => import('@/pages/attribute'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/attribute/:name',
    name: 'page-attribute',
    component: () => import('@/pages/attribute'),
    props: (route) => ({ name: route.params.name }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
